import React, { useRef, useEffect, useState } from 'react';
import './index.less';
import ReactFullpage from '@fullpage/react-fullpage';
import NavigationBar from './navigationBar';
import PageTop from '../pageTop';
import PageTech from '../pageTech';
import PageTools from '../pageTools';
import PageTesting from '../pageTesting';
import PageCase from '../pageCase';
import PageBottom from '../pageBottom';
import PageTalents from '../PageTalents';
import PageScount from '../PageScount';
import PageNcov from '../PageNcov';
import PageScholar from '../pageScholar';
import PagePartner from '../pagePartner';
function useInterval(callback, delay) {
  const savedCallback = useRef();

  useEffect(() => {
      savedCallback.current = callback;
  });

  useEffect(() => {
      function tick() {
          savedCallback.current();
      }
      if (delay !== null) {
          let id = setInterval(tick, delay);
          return () => clearInterval(id);
      }
  }, [delay]);
}

const CogGraph = props => {
    const [ currentPage, setCurrentPage ] = useState(0);
    const [ fpApi, setFpApi ] = useState(null);
    const [ contentAnchor, setContentAnchor ] = useState({left: 0, top: 0, width: 0, height: 0, totalWidth: 0, totalHeight: 0, isMobile: false,scale: 1});
    const totalPage = 6;
    // const totalPage = 10;

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, [])

  const handleResize = () => {
    let totalWidth = document.body.offsetWidth;
    let totalHeight = document.body.offsetHeight;
    let isMobile = totalWidth <= 768;
    let width = totalWidth * 0.628;
    let scale = document.body.offsetWidth/1800;
    
    let top = isMobile ? totalHeight * 0.12 : totalHeight * 0.19;
    setContentAnchor({
      left: (totalWidth - width) / 2,
      top,
      width,
      height: totalHeight,
      totalWidth,
      totalHeight,
      isMobile,
      scale,
    })
  }
  const BubbleMachine = props => {
    const { anchor, vw, bgColor } = props;
    const [bubbles, setBubbles] = useState([]);
    const [next, setNext] = useState(0);
    const width = 1079;
    const wScale = vw * anchor.totalWidth / width;
    const radiusMax = 14;
    const bHeight = 168;
    const origins = [[164, 273], [293, 270], [308, 250], [189, 306], [277, 254], [64, 302], [579, 303], [303, 276], [216, 295], [220, 334], [173, 306], [216, 258],[220,400],[320,333],[420,444],[560,310],[432,345],[70,190],[120,0],[350,20],[30,40],[77,88],[120,430]];

    useInterval(() => {
        let bbs = bubbles.filter((bubble) => {
            bubble.y -= bubble.sy / 200;
            if (bubble.y <= 40) {
                bubble.opacity = bubble.sOpacity * Math.max(0, bubble.y / 40);
            }
            return bubble.opacity > 0;
        });

        let newNext = next - 1;
        if (newNext <= 0) {
            let origin = origins[Math.floor(Math.random() * origins.length)];
            let radius = radiusMax - Math.random() * 10;
            let sy = bHeight + radius * 2 + 10 * Math.random();
            let opacity = 0.9 - Math.random() * 0.6;
            bbs.push({
                key: (new Date).getTime(),
                ox: origin[0],
                oy: origin[1],
                height: bHeight,
                radius,
                sOpacity: opacity,
                opacity,
                sy,
                y: sy
            });
            newNext = Math.random() * 40 + 6;
        }

        setNext(newNext);
        setBubbles(bbs);
    }, 30)

    const handleMapBubble = (bubble, index) => {
        return (
            <div key={bubble.key} style={{
                position: 'absolute',
                left: `${bubble.ox * wScale}px`,
                top: `${bubble.oy * wScale - bubble.height * wScale}px`,
                marginLeft: `${-bubble.radius * wScale}px`,
                width: `${bubble.radius * 2 * wScale}px`,
                height: `${bubble.height * wScale}px`,
                overflow: 'hidden',
                pointerEvents: 'none'
            }}>
                <div style={{
                    position: 'absolute',
                    left: `0`,
                    top: `${bubble.y * wScale}px`,
                    width: `${bubble.radius * 2 * wScale}px`,
                    height: `${bubble.radius * 2 * wScale}px`,
                    borderRadius: `${bubble.radius * wScale}px`,
                    backgroundColor: bgColor,
                    opacity: `${bubble.opacity * wScale}`
                }} />
            </div>
        )
    }

    return (
        <div style={{
            position: 'absolute',
            left: '0',
            top: '0',
            pointerEvents: 'none'
        }}>
            {bubbles.map(handleMapBubble)}
        </div>
    )
}

  const bottomLogo1Style = {
    width: `${contentAnchor.totalWidth*0.1114*(contentAnchor.isMobile? 2.4 : 1)}px`, 
    left: '50%', 
    marginLeft: `${-contentAnchor.totalWidth*0.0557*(contentAnchor.isMobile? 2.4 : 1)}px`, 
    top: `${contentAnchor.isMobile?'40%':"50%"}`, 
    marginTop: `${-contentAnchor.totalWidth*0.1552*(contentAnchor.isMobile? 2.4 : 1)}px`
  }

  const bottomLogo2Style = {
    width: `${contentAnchor.totalWidth*0.15*(contentAnchor.isMobile? 2 : 1)}px`,
    left: '50%',
    marginLeft: `${-contentAnchor.totalWidth*0.075*(contentAnchor.isMobile? 2 : 1)}px`,
    top: `${contentAnchor.isMobile?'40%':"50%"}`,
    marginTop: `${-contentAnchor.totalWidth*0.0208*(contentAnchor.isMobile? 2.4 : 1)}px`
  }
  return (
    <div className="coggraph">
      <ReactFullpage 
        licenseKey={""}
        onLeave={(origin, destination) => setCurrentPage(destination.index)}
        render={({state, fullpageApi }) => {
          if(!fpApi) setFpApi(fullpageApi);
          return (
            <div>
              <ReactFullpage.Wrapper>
                <div className="section">
                  <PageTop 
                    anchor={contentAnchor} 
                    current={currentPage} 
                    BubbleMachine={BubbleMachine}
                    onChange={(index) => fullpageApi.moveTo(index+1)} />
                </div>
                <div className="section">
                  <PageScholar 
                    anchor={contentAnchor} 
                    current={currentPage}
                    BubbleMachine={BubbleMachine}/>
                </div>
                <div className="section">
                  <PageTech 
                    anchor={contentAnchor}
                    current={currentPage}
                    BubbleMachine={BubbleMachine} />
                </div>
                <div className="section">
                  <PageNcov anchor={contentAnchor} />
                </div>
                <div className="section">
                  <PagePartner 
                    anchor={contentAnchor}
                    current={currentPage}
                    BubbleMachine={BubbleMachine}/>
                </div>
                {/* <div className="section"><PageTalents anchor={contentAnchor} /></div> */}
                {/* <div className="section"><PageCase anchor={contentAnchor} /></div> */}
                {/* <div className="section"><PageTools anchor={contentAnchor} /></div> */}
                {/* <div className="section"><PageTesting anchor={contentAnchor} /></div> */}
                {/* <div className="section"><PageScount anchor={contentAnchor} /></div> */}
                <div className="section">
                  <PageBottom anchor={contentAnchor} current={currentPage}/>
                </div>
              </ReactFullpage.Wrapper>
            </div>
          )
        }} />
      <div className="coggraph_logo">
        <img className="coggraph_logo1" src={'/assets/logo1.png'} style={currentPage == totalPage-1 ? bottomLogo1Style : undefined}/>
        <img className="coggraph_logo2" src={'/assets/logo2.png'} style={currentPage == totalPage-1 ? bottomLogo2Style : undefined}/>
      </div>
      {
        currentPage != 0 && (
          <div className="navigationbar">
            <NavigationBar anchor={contentAnchor} currentIndex={currentPage} total={totalPage} changeIndex={(index) => fpApi && fpApi.moveTo(index+1)} />
          </div>
        )
      }
    </div>
  );
};

export default CogGraph;
